/*
011 Behandlung regulär beendet - arbeitsfähig entlassen
012 Behandlung regulär beendet - arbeitsunfähig entlassen
019 Behandlung regulär beendet - keine Angabe
021 Behandlung regulär beendet, nachstationäre Behandlung vorgesehen - arbeitsfähig entlassen
022 Behandlung regulär beendet, nachstationäre Behandlung vorgesehen - arbeitsunfähig entlassen
029 Behandlung regulär beendet, nachstationäre Behandlung vorgesehen - keine Angabe
031 Behandlung aus sonstigen Gründen beendet - arbeitsfähig entlassen
032 Behandlung aus sonstigen Gründen beendet - arbeitsunfähig entlassen
039 Behandlung aus sonstigen Gründen beendet - keine Angabe
041 Behandlung gegen ärztlichen Rat beendet - arbeitsfähig entlassen
042 Behandlung gegen ärztlichen Rat beendet - arbeitsunfähig entlassen
049 Behandlung gegen ärztlichen Rat beendet - keine Angabe
059 Zuständigkeitswechsel des Kostenträgers (bei tagesbezogenen Entgelten)
069 Verlegung in ein anderes Krankenhaus
079 Tod
089 Verlegung in ein anderes Krankenhaus im Rahmen einer Kooperation
099 Entlassung in eine Rehabilitationseinrichtung
109 Entlassung in eine Pflegeeinrichtung
119 Entlassung in ein Hospiz
139 externe Verlegung zur psychiatrischen Behandlung
141 Behandlung aus sonstigen Gründen beendet, nachstationäre Behandlung vorgesehen - arbeitsfähig entlassen
142 Behandlung aus sonstigen Gründen beendet, nachstationäre Behandlung vorgesehen - arbeitsunfähig entlassen
149 Behandlung aus sonstigen Gründen beendet, nachstationäre Behandlung vorgesehen - keine Angabe
151 Behandlung gegen ärztlichen Rat beendet, nachstationäre Behandlung vorgesehen - arbeitsfähig entlassen
152 Behandlung gegen ärztlichen Rat beendet, nachstationäre Behandlung vorgesehen - arbeitsunfähig entlassen
159 Behandlung gegen ärztlichen Rat beendet, nachstationäre Behandlung vorgesehen - keine Angabe
179 interne Verlegung mit Wechsel zwischen den Entgeltbereichen der DRG-Fallpauschalen, nach der BPflV oder für besondere Einrichtungen nach §17bAbs.1 Satz15 KHG
229 Fallabschluss (interne Verlegung) bei Wechsel zwischen voll-,teilstationärerund stationsäquivalenterBehandlung
239 Beginn eines externen Aufenthalts mit Abwesenheit über Mitternacht (BPflV-Bereich, für verlegende Fachabteilung)
249 Beendigung eines externen Aufenthalts mit Abwesenheit über Mitternacht (BPflV-Bereich, für Pseudo-Fachabteilung 0003)
259 Entlassung zum Jahresende bei Aufnahme im Vorjahr (für Zwecke der Abrechnung, §4 PEPPV)
269 Beginn eines Zeitraumes ohne direkten Patientenkontakt (stationsäquivalente Behandlung)
279 Beendigung eines Zeitraumes ohne direkten Patientenkontakt (stationsäquivalente Behandlung –für Pseudofachabteilung 0004)
289 Behandlung regulär beendet, beatmet entlassen
299 Behandlung regulär beendet, beatmet verlegt
 */

export type BdVirtualClinicDismissionCause =
  | '011'
  | '012'
  | '019'
  | '021'
  | '022'
  | '029'
  | '031'
  | '032'
  | '039'
  | '041'
  | '042'
  | '049'
  | '059'
  | '069'
  | '079'
  | '089'
  | '099'
  | '109'
  | '119'
  | '139'
  | '141'
  | '142'
  | '149'
  | '151'
  | '152'
  | '159'
  | '179'
  | '229'
  | '239'
  | '249'
  | '259'
  | '269'
  | '279'
  | '289'
  | '299';

const DISMISSION_CAUSE_DISPLAY_NAMES = {
  '011': 'Behandlung regulär beendet - arbeitsfähig entlassen',
  '012': 'Behandlung regulär beendet - arbeitsunfähig entlassen',
  '019': 'Behandlung regulär beendet - keine Angabe',
  '021':
    'Behandlung regulär beendet, nachstationäre Behandlung vorgesehen - arbeitsfähig entlassen',
  '022':
    'Behandlung regulär beendet, nachstationäre Behandlung vorgesehen - arbeitsunfähig entlassen',
  '029':
    'Behandlung regulär beendet, nachstationäre Behandlung vorgesehen - keine Angabe',
  '031': 'Behandlung aus sonstigen Gründen beendet - arbeitsfähig entlassen',
  '032': 'Behandlung aus sonstigen Gründen beendet - arbeitsunfähig entlassen',
  '039': 'Behandlung aus sonstigen Gründen beendet - keine Angabe',
  '041': 'Behandlung gegen ärztlichen Rat beendet - arbeitsfähig entlassen',
  '042': 'Behandlung gegen ärztlichen Rat beendet - arbeitsunfähig entlassen',
  '049': 'Behandlung gegen ärztlichen Rat beendet - keine Angabe',
  '059': 'Zuständigkeitswechsel des Kostenträgers (bei tagesbezogenen Entgelten)',
  '069': 'Verlegung in ein anderes Krankenhaus',
  '079': 'Tod',
  '089': 'Verlegung in ein anderes Krankenhaus im Rahmen einer Kooperation',
  '099': 'Entlassung in eine Rehabilitationseinrichtung',
  '109': 'Entlassung in eine Pflegeeinrichtung',
  '119': 'Entlassung in ein Hospiz',
  '139': 'externe Verlegung zur psychiatrischen Behandlung',
  '141':
    'Behandlung aus sonstigen Gründen beendet, nachstationäre Behandlung vorgesehen - arbeitsfähig entlassen',
  '142':
    'Behandlung aus sonstigen Gründen beendet, nachstationäre Behandlung vorgesehen - arbeitsunfähig entlassen',
  '149':
    'Behandlung aus sonstigen Gründen beendet, nachstationäre Behandlung vorgesehen - keine Angabe',
  '151':
    'Behandlung gegen ärztlichen Rat beendet, nachstationäre Behandlung vorgesehen - arbeitsfähig entlassen',
  '152':
    'Behandlung gegen ärztlichen Rat beendet, nachstationäre Behandlung vorgesehen - arbeitsunfähig entlassen',
  '159':
    'Behandlung gegen ärztlichen Rat beendet, nachstationäre Behandlung vorgesehen - keine Angabe',
  '179':
    'interne Verlegung mit Wechsel zwischen den Entgeltbereichen der DRG-Fallpauschalen, nach der BPflV oder für besondere Einrichtungen nach §17bAbs.1 Satz15 KHG',
  '229':
    'Fallabschluss (interne Verlegung) bei Wechsel zwischen voll-,teilstationärerund stationsäquivalenterBehandlung',
  '239':
    'Beginn eines externen Aufenthalts mit Abwesenheit über Mitternacht (BPflV-Bereich, für verlegende Fachabteilung)',
  '249':
    'Beendigung eines externen Aufenthalts mit Abwesenheit über Mitternacht (BPflV-Bereich, für Pseudo-Fachabteilung 0003)',
  '259':
    'Entlassung zum Jahresende bei Aufnahme im Vorjahr (für Zwecke der Abrechnung, §4 PEPPV)',
  '269':
    'Beginn eines Zeitraumes ohne direkten Patientenkontakt (stationsäquivalente Behandlung)',
  '279':
    'Beendigung eines Zeitraumes ohne direkten Patientenkontakt (stationsäquivalente Behandlung –für Pseudofachabteilung 0004)',
  '289': 'Behandlung regulär beendet, beatmet entlassen',
  '299': 'Behandlung regulär beendet, beatmet verlegt',
} as const;

export const BD_VIRTUAL_CLINIC_DISMISSION_CAUSE_DISPLAY_NAMES: {
  [dismissionCause in BdVirtualClinicDismissionCause]: string;
} = DISMISSION_CAUSE_DISPLAY_NAMES;

export type DismissionCauseDisplayName =
  (typeof DISMISSION_CAUSE_DISPLAY_NAMES)[keyof typeof DISMISSION_CAUSE_DISPLAY_NAMES];
